import { makeStyles } from 'tss-react/mui';

import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'Item' })((theme) => {
    return {
        root: {
            display: 'flex',
            padding: '12px 16px',
            alignItems: 'center',
            gap: 20,
            borderRadius: 8,
            color: isLightMode(theme) ? '#232323' : '#fff',
            fontSize: 18,
            fontWeight: 500,
            lineHeight: '20px',
            textDecoration: 'none',
            transition: 'all 0.2s',
            '&:hover': {
                background: '#FFFFFF0D'
            },
            '&:active': {
                background: '#FFFFFF0D'
            }
        }
    };
});
